export default "__VITE_ASSET__Dpl0bu_t__"